<template>
  <div>
    <div class="control-group">
      <label class="control-label" for="identidade">{{field}}</label>
      <div class="controls input-group" style="width: 100% !important;">
        <input type="file" @change="onFileChanged" class="form-control input-small" />

        <p v-if="loading" class="input-group-addon">
          <i class="fa fa-spinner fa-spin text-info"></i>
        </p>
        <p v-if="!loading && !selectedFile" class="input-group-addon">
          <i class="fa fa-exclamation-triangle  text-danger"></i>
        </p>
         <p v-if="!loading && selectedFile" class="input-group-addon">
          <i class="fa fa-check-circle text-success"></i>
        </p>
      </div>
    </div>
  </div>
</template>


<script>
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  props: ["field", "filetype", "folder"],
  data() {
    return {
      loading: false,
      selectedFile: null
    };
  },
  components: {},
  methods: {
    onFileChanged(event) {
      this.selectedFile = event.target.files[0];
      this.onUpload();
    },
    onUpload() {
      this.loading = true;

      const formData = new FormData();
      formData.append("file", this.selectedFile, this.selectedFile.name);

      var urlPost = "/upload";

      if (this.folder != undefined) {
        urlPost = urlPost + "?folder=" + this.folder;
      }

      const path = this.$global.endpoint + urlPost;
      axios
        .post(path, formData)
        .then(res => {
          this.$emit("uploadComplete", res.data);
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          this.$notify({
            type: "error",
            group: "foo",
            title: "Erro",
            text: "Erro ao fazer o upload do arquivo"
          });
          console.error(error);
        });
    }
  },
  created() {}
};
</script>
